import React, { useState, useEffect } from 'react';
import './LoadingExames.css';

const LoadingExames = ({
    phrases = [
        "Adicionando os procedimentos confirmados...",
        "Conferindo as informações para continuar"
    ],
    timeoutDuration = 5000
}) => {
    const [phraseIndex, setPhraseIndex] = useState(0);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setPhraseIndex(1);
        }, timeoutDuration);

        return () => clearTimeout(timeoutId);
    }, [timeoutDuration]);

    return (
        <div className="loading-exames-container">
            <div className="loading-exames-spinner"></div>
            <div className="loading-exames-phrase">{phrases[phraseIndex] || phrases[phrases.length - 1]}</div>
        </div>
    );
};

export default LoadingExames;
